<template>
    <div class="body-panel dataContent">
        <template v-if="task != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex mob-inline">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                        </p>
                        <p class="caption-help margin-right-10" v-if="answerId === 0">Новый ответ</p>
                        <p class="caption-help margin-right-10" v-if="answerId > 0">Статус: {{ stateFormatted }}</p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex" v-if="isController">
                        <div class="svg-container margin-right-10 margin-top-3" v_if="task.DenyExecutionOnSite" @click="onInfoOpen">
                            <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="width:24px;height:24px;">
                                <use :xlink:href="'/Content/dist/images.svg#MenuHelp'"></use>
                            </svg>
                        </div>
                        <button type="button" class="btn btn-primary" @click="saveAnswer(null, null, true)" v-if="enableBtnSave(task.LastStatusSelectAnswer.Id)">Сохранить</button>
                        <button type="button" class="btn btn-primary" @click="saveAnswer(2, null)" v-if="enableBtnAccept(task.LastStatusSelectAnswer.Id)">Принять</button>
                        <button type="button" class="btn btn-delete" @click="btnReject(4)" v-if="enableBtnFinalize(task.LastStatusSelectAnswer.Id)">Доработать</button>
                        <button type="button" class="btn btn-delete" @click="btnReject(5)" v-if="enableBtnFinalize(task.LastStatusSelectAnswer.Id)">Отклонить</button>
                        <button type="button" class="btn btn-primary" @click="back">Отмена</button>
                        <button type="button" class="btn btn-delete" @click="btnAccept(10, null)" v-if="info.User.MainRole === 'administrators'">Удалить</button>
                    </div>
                    <div class="btns flex" v-else>
                        <button type="button" v-if="allowEdit && !isController" class="btn btn-primary" @click="saveAnswer(null, null)">Сохранить</button>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <template v-if="tradePointSelected">
                    <h1 class="margin-bottom-20">{{task.Name}}</h1>
                    <div class="flex mob-flex-to-block margin-bottom-20">
                        <div class="panel-block panel-block-large">
                            <div class="panel-block-info">
                                <p class="task-header">Описание задачи</p>
                                <span class="block-descr" style="height:auto" v-html="task.CaptionFormatted"></span>
                            </div>
                        </div>
                        <div class="panel-block panel-block-large">
                            <div class="panel-block-info">
                                <div class="flex task-photo-block">
                                    <div class="form-field" style="width:50%">
                                        <p class="task-header">Файлы</p>
                                        <div class="flex" style="flex-wrap:wrap">
                                            <div class="task-photo" v-for="(item, i) of taskAttachmentsNoImage">
                                                <a target="_blank" :href="item.FilePath" class="task-photo-file">
                                                    <svg class="tasks-svg svg-icon" v-if="item.Extension==='docx'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <use xlink:href="/Content/dist/image_svg.svg?v2#Docx" />
                                                    </svg>
                                                    <svg class="tasks-svg svg-icon" v-if="item.Extension==='xlsx'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <use xlink:href="/Content/dist/image_svg.svg?v2#Xlsx" />
                                                    </svg>
                                                    <svg class="tasks-svg svg-icon" v-if="item.Extension==='pdf'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <use xlink:href="/Content/dist/image_svg.svg?v2#Pdf" />
                                                    </svg>
                                                    <span>{{item.FileName}}</span>
                                                </a>
                                            </div>
                                        </div>
                                        <p class="input-text-lbl" v-if="taskAttachmentsNoImage.length === 0">Файлы отсутствуют</p>
                                    </div>
                                    <div class="form-field" style="width:50%">
                                        <p class="task-header">Фото</p>
                                        <div class="task-photo flex" v-for="(item, i) of taskAttachmentsImage">
                                            <a target="_blank" :href="item.FilePath" class="lightzoom" rel="group">
                                                <img :src="item.FilePath" />
                                            </a>
                                        </div>
                                        <p class="input-text-lbl" v-if="taskAttachmentsImage.length === 0">Фото отсутствуют</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <div class="block-in-page" v-if="!tradePointSelected" @scroll="onReportItemsScroll">
                    <div>
                        <div class="body-panel-control-separator flex">
                            <input type="text" v-model="ttSearch" value="1" @input="onChangeTradeSearch" class="input-text" placeholder="Введите название или адрес торговой точки, после чего выберите из списка" />
                        </div>
                    </div>
                    <div>
                        <br>
                        <table class="table-view" id="dataTable">
                            <tbody>
                                <tr v-for="item of ttData">
                                    <td>{{item.FullName}}</td>
                                    <td class="phone">
                                        <button v-if="!item.Error" type="button" class="btn btn-primary" @click="onSelectTradePoint(item)" style="display:unset">Добавить</button>
                                        <span v-if="item.Error">
                                            {{item.Error}}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="ttSearched && !ttData.length && !ttIsLoading">
                            <span>Ничего не найдено...</span>
                        </div>
                    </div>
                </div>
                <div class="block-in-page" v-if="currentAnswer.TradePoint && !currentAnswer.TradePoint.Error || tradePointSelected && answerId > 0">
                    <div v-if="currentAnswer.TradePoint && !currentAnswer.TradePoint.Error">
                        Торговая точка: <strong>{{ formatTradePointName(currentAnswer.TradePoint) }}</strong>
                    </div>
                    <div v-if="tradePointSelected && answerId > 0">
                        <div>
                            ID ответа: <strong>{{ currentAnswer.Id }}</strong>
                        </div>
                        <div>
                            ФИО: <strong>{{ currentAnswer.User.Fio }}</strong>
                        </div>
                    </div>
                </div>
                <div class="error" v-if="currentAnswer.TradePoint && currentAnswer.TradePoint.Error">
                    {{ currentAnswer.TradePoint.Error }}
                </div>

                <h2 class="margin-bottom-20" v-if="tradePointSelected">Детали ответа</h2>
                <div class="margin-bottom-20" v-if="tradePointSelected">
                    Дата ответа:
                    <input-date name="'dateAnswer'" v-model="currentAnswer.FillingDateFormatted" disabled="true" class="'input-text input-date'"></input-date>
                </div>
                <div v-if="tradePointSelected">

                    <div class="error" v-if="currentAnswer.CommentStatus && currentAnswer.LastStatus === TaskAnswerStates.OnEdition">
                        {{ currentAnswer.CommentStatus }}
                    </div>
                    <div class="error" v-else-if="currentAnswer.CommentStatus && currentAnswer.LastStatus === TaskAnswerStates.Finalized" >
                        Ранее ответ был отправлен на доработку с комментарием: {{currentAnswer.CommentStatus}}
                    </div>

                    <div class="error" v-else-if="currentAnswer.CommentStatus && currentAnswer.LastStatus === TaskAnswerStates.Rejected">
                        Ранее ответ был отклонен с комментарием: {{currentAnswer.CommentStatus}}
                    </div>
                    <div class="report-block-items margin-bottom-20" v-if="task.FieldInputType === FieldType.Table">
                        <report-items-table ref="reportItems" class="report-items"
                                            v-model="fieldTable.ReportItems"
                                            v-if="task.FieldInputType === FieldType.Table"
                                            :bonusSettings="fieldTable.bonusSettings"
                                            :tradePoint="fieldTable.TradePoint"
                                            :reportSettings="fieldTable.reportSettings"
                                            :equipmentTypes="fieldTable.equipmentTypes"
                                            :sku="fieldTable.sku"
                                            :canBeEdited="fieldTable.canBeEdited"
                                            :minItems="fieldTable.minItems"
                                            :maxItems="fieldTable.maxItems"
                                            :skuBonusList="fieldTable.skuBonusList"
                                            :isNewAnswer="answerId === 0"
                        ></report-items-table>
                    </div>
                    <div class="flex" style="flex-wrap:wrap" v-if="(!isController || allowEdit) && (task.FieldInputType === FieldType.Single || existsAttach)">
                        <template v-for="(settings, i) of fieldSettingsOrdered">
                            <div class="panel-block panel-block-large panel-block-field" v-if="task.FieldInputType === FieldType.Single && settings.type !== 'attach'">
                                <div class="panel-block-info">
                                    <div class="form-field">
                                        <p class="task-header">{{settings.caption}}</p>
                                        <label class="input-text-lbl margin-bottom-5">{{settings.description}}</label>
                                        <template v-if="settings.type === 'int'">
                                            <touch-spin v-model="fieldTable.ReportItems[0].Fields[settings.index].Value" :name="'settingsAnswer' + i" :decimals="0" :step="1.00" v-validate="{ required: true }" :disabled="!allowEdit"
                                                        :class="['input-text', {'input-error': errors.has('settingsAnswer' + i)}]"></touch-spin>
                                            <span class="field-validation-valid" v-if="errors.has('settingsAnswer' + i)">Обязательно для заполнения</span>
                                        </template>
                                        <template v-else-if="settings.type === 'date'">
                                            <input-date :name="'settingsAnswer' + i" v-validate="'required'" v-model="fieldTable.ReportItems[0].Fields[settings.index].Title" :disabled="!allowEdit"
                                                        @input="onChangeDate(fieldTable.ReportItems[0].Fields[settings.index], 'Title', 'Value')" todayHighlight="true"
                                                        :class="['input-text', {'input-error': errors.has('settingsAnswer' + i)}]"></input-date>
                                            <span class="field-validation-valid" v-if="errors.has('settingsAnswer' + i)">Обязательно для заполнения</span>
                                        </template>
                                        <template v-else-if="settings.type === 'decimal'">
                                            <touch-spin v-model="fieldTable.ReportItems[0].Fields[settings.index].Value" :name="'settingsAnswer' + i" :decimals="2" :step="0.01" v-validate="{ required: true }" :disabled="!allowEdit"
                                                        :class="['input-text', {'input-error': errors.has('settingsAnswer' + i)}]"></touch-spin>
                                            <span class="field-validation-valid" v-if="errors.has('settingsAnswer' + i)">Обязательно для заполнения</span>
                                        </template>
                                        <template v-else-if="settings.type === 'string'">
                                            <input type="text" placeholder="Ответ" :name="'settingsAnswer' + i" v-model="fieldTable.ReportItems[0].Fields[settings.index].Value"
                                                   v-validate="'required'" :disabled="!allowEdit" :class="['input-text', {'input-error': errors.has('settingsAnswer' + i)}]" />
                                            <span class="field-validation-valid" v-if="errors.has('settingsAnswer' + i)">Обязательно для заполнения</span>
                                        </template>
                                        <template v-else-if="settings.type === 'bool'">
                                            <drop-down :items="fieldSettingsBool" :dataField="'Id'" :textField="'Name'" :disabled="!allowEdit" v-model="fieldTable.ReportItems[0].Fields[settings.index].Value"></drop-down>
                                            <span class="field-validation-valid" v-if="errors.has('settingsAnswer' + i)">Обязательно для заполнения</span>
                                        </template>
                                        <template v-else-if="settings.type === 'sku'">
                                            <search-filter :name="'settingsAnswer' + i" ref="searchfilter"
                                                           v-validate="{ rules: { required: true} }"
                                                           :hasErrors="errors.has('settingsAnswer' + i)"
                                                           :extra="0"
                                                           :placeholder="('Выберите sku')"
                                                           :searchFunction="searchSkuFunction"
                                                           :selectedItem="getSkuSelectedItem(fieldTable.ReportItems[0].Fields[settings.index])"
                                                           :searchOnSelect="true"
                                                           :scrollable="true"
                                                           :fieldName="settings.name"
                                                           :disabled="!allowEdit"
                                                           :valueItem="skuValueItem"
                                                           @onFilterChange="onChangeSkuSearch(...arguments, settings.name)"></search-filter>
                                        </template>
                                        <template v-else-if="settings.type === 'select'">
                                            <drop-down :items="settings.optionsItems" :dataField="'Value'" :textField="'Name'" :disabled="!allowEdit" v-model="fieldTable.ReportItems[0].Fields[settings.index].Value"></drop-down>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="task-files-newline" v-if="settings.type === 'attach'"></div>
                            <div class="panel-block task-files-block" style="min-width: 200px;" v-if="settings.type === 'attach'">
                                <div class="panel-block-info">
                                    <div class="form-field">
                                        <p class="task-header">{{settings.caption}}</p>
                                        <label class="input-text-lbl margin-bottom-5">{{settings.description}}</label>
                                        <div class="flex" style="flex-wrap:wrap">
                                            <div :class="['task-photo', {'thumbnail-img' : item.isImage}]" v-for="(item, j) of settings.Attachments">
                                                <template v-if="!item.isImage">
                                                    <a target="_blank" v-if="!item.FileData && item.FilePath" :href="item.FilePath" class="task-photo-file">
                                                        <svg class="tasks-svg svg-icon" v-if="item.Extension==='docx'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                            <use xlink:href="/Content/dist/image_svg.svg?v2#Docx" />
                                                        </svg>
                                                        <svg class="tasks-svg svg-icon" v-if="item.Extension==='xlsx'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                            <use xlink:href="/Content/dist/image_svg.svg?v2#Xlsx" />
                                                        </svg>
                                                        <svg class="tasks-svg svg-icon" v-if="item.Extension==='pdf'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                            <use xlink:href="/Content/dist/image_svg.svg?v2#Pdf" />
                                                        </svg>
                                                        <span>{{item.FileName}}</span>
                                                        <span class="file-del" @click="onRemoveAttachment(settings, j)" v-if="allowEdit">удалить</span>
                                                    </a>
                                                    <div v-else class="task-photo-file">
                                                        <svg class="tasks-svg svg-icon" v-if="item.Extension==='docx'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                            <use xlink:href="/Content/dist/image_svg.svg?v2#Docx" />
                                                        </svg>
                                                        <svg class="tasks-svg svg-icon" v-if="item.Extension==='xlsx'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                            <use xlink:href="/Content/dist/image_svg.svg?v2#Xlsx" />
                                                        </svg>
                                                        <svg class="tasks-svg svg-icon" v-if="item.Extension==='pdf'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                            <use xlink:href="/Content/dist/image_svg.svg?v2#Pdf" />
                                                        </svg>
                                                        <span>{{item.FileName}}</span>
                                                        <span class="file-del" @click="onRemoveAttachment(settings, j)" v-if="allowEdit">удалить</span>
                                                    </div>
                                                </template>
                                                <template v-if="item.isImage">
                                                    <a target="_blank" v-if="item.FileData" class="lightzoom-type2" rel="group">
                                                        <img :src="item.FileData" />
                                                    </a>
                                                    <a target="_blank" v-if="!item.FileData && item.FilePath" :href="item.FilePath" class="lightzoom-type2" rel="group">
                                                        <img :src="item.FilePath" />
                                                    </a>
                                                    <button type="button" class="btn btn-default btn-img" @click.stop="onRemoveAttachment(settings, j)" v-if="allowEdit">
                                                        <img src="../../../img/icon-del.png" alt="" />
                                                    </button>
                                                    <div class="thumbnail-img-rotateleft" @click="rotateImage('left', item)" v-if="!item.FileData && item.FilePath && allowEdit"></div>
                                                    <div class="thumbnail-img-rotateright" @click="rotateImage('right', item)" v-if="!item.FileData && item.FilePath && allowEdit"></div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="file-upload-zone">
                                            <drop-zone class="drop-area" @files-dropped="onAttachFiles" :dataId="settings.id" :accept="settings.accept">
                                                <input type="file" v-if="allowEdit" multiple
                                                       class="file-upload-zone-btn" :accept="settings.accept"
                                                       :id="'atDropFiles2'+i" :data-fieldid="settings.id"
                                                       :ref="'atDropFiles2'+i"
                                                       name="atDropFiles2" />
                                                <label id="'atLblDropFiles2'+i" :for="'atDropFiles2'+i" class="file-upload-zone-lbl" v-if="allowEdit">Перетащите файлы или нажмите, чтобы выбрать</label>
                                            </drop-zone>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="task-files-newline" v-if="settings.type === 'attach'"></div>
                        </template>
                    </div>
                    <div v-if="isController && !allowEdit">
                        <div class="flex margin-bottom-30" style="flex-wrap:wrap" v-if="task.FieldInputType === FieldType.Single || existsAttach">
                            <template v-for="(settings, i) of fieldSettingsOrdered">
                                <div class="panel-block panel-block-large" v-if="task.FieldInputType === FieldType.Single && settings.type !== 'attach'">
                                    <div class="panel-block-info">
                                        <div class="form-field">
                                            <p class="task-header">{{ settings.caption }}</p>
                                            <label class="input-text-lbl margin-bottom-5">{{settings.description}}</label>
                                            <template v-if="settings.type === 'int' || settings.type === 'decimal' || settings.type === 'string' || settings.type === 'select'">
                                                <p>{{fieldTable.ReportItems[0].Fields[settings.index].Value}}</p>
                                            </template>
                                            <template v-else>
                                                <p>{{fieldTable.ReportItems[0].Fields[settings.index].Title}}</p>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="task-files-newline" v-if="settings.type === 'attach'"></div>
                                <div class="panel-block task-files-block" v-if="settings.type === 'attach'">
                                    <div class="panel-block-info">
                                        <p class="task-header">{{settings.caption}}</p>
                                        <label class="input-text-lbl margin-bottom-5">{{settings.description}}</label>
                                        <div class="flex" style="flex-wrap:wrap">
                                            <div class="task-photo" v-for="(item, j) of settings.Attachments">
                                                <template v-if="!item.isImage">
                                                    <a target="_blank" v-if="item.FilePath" :href="item.FilePath" class="task-photo-file">
                                                        <svg class="tasks-svg svg-icon" v-if="item.Extension==='docx'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                            <use xlink:href="/Content/dist/image_svg.svg?v2#Docx" />
                                                        </svg>
                                                        <svg class="tasks-svg svg-icon" v-if="item.Extension==='xlsx'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                            <use xlink:href="/Content/dist/image_svg.svg?v2#Xlsx" />
                                                        </svg>
                                                        <svg class="tasks-svg svg-icon" v-if="item.Extension==='pdf'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                            <use xlink:href="/Content/dist/image_svg.svg?v2#Pdf" />
                                                        </svg>
                                                        <span>{{item.FileName}}</span>
                                                    </a>
                                                </template>
                                                <a v-else target="_blank" :href="item.FilePath" class="lightzoom-type2" rel="group">
                                                    <img :src="item.FilePath" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="task-files-newline" v-if="settings.type === 'attach'"></div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <popup-window ref="ppComment" :title="popuptitle" :width="800">
            <div class="">
                <div class="form-field">
                    <label class="input-text-lbl"> </label>
                    <textarea rows="10"
                              :name="'SettingsDescription'"
                              :class="['input-memo', {'input-error': errors.has('SettingsDescription', 'edition')}]"
                              v-model="commentStatus"
                              v-validate="'required'"
                              data-vv-scope="edition"></textarea>
                    <span class="field-validation-valid" v-if="errors.has('SettingsDescription', 'edition')">Заполните поле</span>
                </div>
                <div class="btns flex margin-top-20 margin-bottom-20">
                    <button type="button" class="btn" @click="validatePopup()">Принять</button>
                    <button type="button" class="btn" @click.stop="closeModal('ppComment')">Отмена</button>
                </div>
            </div>
        </popup-window>

        <popup-window ref="ppInfo" title="Информация" :width="800">
            <div class="">
                <div class="form-field">
                    <label class="input-text-lbl">Время открытия ответа: {{currentAnswer.DateOpenLong}}</label>
                    <label class="input-text-lbl">Время сохранения ответа: {{currentAnswer.FillingDateLong}}</label>
                    <label class="input-text-lbl">Координаты заполнения ответа: {{currentAnswer.Latitude}} {{currentAnswer.Longitude}}</label>
                </div>
                <div class="btns flex margin-top-20 margin-bottom-20">
                    <button type="button" class="btn" @click.stop="closeModal('ppInfo')">Ок</button>
                </div>
            </div>
        </popup-window>

        <vue-headful :title="titleName" />
    </div>
</template>

<script>
    //let $ = require('jquery');

    import $ from 'jquery'
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import moment from 'moment'
    import { Draggable } from 'vue-smooth-dnd'
    import {FieldTypes, MemberFilters, ScoringAccrualType, TaskTypes, TaskAnswerStates} from '../../enums'
    import ReportItemsTable from '../../components/ReportItemsTable'
    import imgMixin from '../../helpers/img-mixin'

    let backendApi = new BackendApi();

    export default {
        name: "tasks-edit",

        props: ['info'],

        mixins: [imgMixin],

        components: { Draggable, ReportItemsTable },

        data() {
            return {
                task: null,
                taskId: 0,
                answerId: 0,
                fixTT: false,
                commentStatus: '',
                selectStatus: 0,
                popuptitle: 'Причина отправки на доработку',
                titleName: 'Ответ',
                fieldSettingsBool: [
                    { Id: 1, Name: 'Да' },
                    { Id: 0, Name: 'Нет' }
                ],
                fieldSettingsSelect: [],
                allowEdit: false,
                currentAnswer: {},
                isController: false,
                fieldTable: null,
                bonusSettings: null,
                FieldType: FieldTypes,
                TaskTypes: TaskTypes,
                existsAttach: false,
                skuValueItem: 0,

                ttSearch: null,
                ttAllowed: true,
                ttData: [],
                ttPage: 1,
                ttIsLoading: false,
                ttCanBeLoaded: true,
                ttSearched: false,
                FieldSettings: [],
            }
        },

        computed: {
          TaskAnswerStates() {
            return TaskAnswerStates
          },
            fieldSettingsOrdered: function () {
                return _.orderBy(this.FieldSettings, 'itemOrder');
            },

            taskAttachmentsImage: function () {
                return this.task.TasksAttachments.filter((x) => { return x.isImage });
            },

            taskAttachmentsNoImage: function () {
                return this.task.TasksAttachments.filter(x => !x.isImage);
            },

            tradePointSelected() {
                return this.answerId > 0 || !this.task.FixTT || this.currentAnswer.TradePoint && this.currentAnswer.TradePoint.Id && this.currentAnswer.TradePoint.Error == null;
            },

            stateFormatted() {
                let state = '';
                switch (this.currentAnswer.LastStatus){
                    case 1: state = 'Ждет проверки'; break;
                    case 2: state = 'Проверено'; break;
                    case 3: state = 'Доработано'; break;
                    case 4: state = 'На доработке'; break;
                    case 5: state = 'Отклонено'; break;
                }
                return state;
            }
        },

        watch: {
            'task.Preview': function () {
                this.task.PreviewFormatted = this.task.Preview ? this.task.Preview.replace(/\n/g, '<br>') : null;
            }
        },

        methods: {
            back() {
                this.$router.back();
            },

            onChangeDate(item, formatted, raw) {
                item[raw] = moment(item[formatted], 'DD.MM.YYYY').format();
            },

            fieldSettingsBoolStr(id) {
                return id == 1 ? 'Да' : 'Нет';
            },

            enableBtnSave(lastStatus) {
                return lastStatus === TaskAnswerStates.WaitingVerification;
            },

            enableBtnAccept(lastStatus) {
                return lastStatus === TaskAnswerStates.WaitingVerification || lastStatus === TaskAnswerStates.Finalized
                    || lastStatus === TaskAnswerStates.OnEdition || lastStatus === TaskAnswerStates.Rejected;
            },

            enableBtnFinalize(lastStatus) {
                return lastStatus === TaskAnswerStates.WaitingVerification || lastStatus === TaskAnswerStates.Accepted
                    || lastStatus === TaskAnswerStates.Finalized || lastStatus === TaskAnswerStates.OnEdition;
            },

            enableBtnRejected(lastStatus) {
                return lastStatus === TaskAnswerStates.WaitingVerification || lastStatus === TaskAnswerStates.Accepted || lastStatus === TaskAnswerStates.Finalized;
            },

            getStateClass(item) {
                return 'task-state-' + item.LastStatus;
            },

            loadTask() {
                let vm = this;
                let taskId = parseInt(this.$route.params.taskId);
                let tradePointId = parseInt(this.$route.query.tpid);
                vm.answerId = parseInt(this.$route.params.answerId);
                vm.isController = this.$route.params.edit === 'checking' || vm.info.User.MainRole === 'administrators'
                    || vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksEdit) || vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksController);
                vm.allowEdit = (this.$route.params.edit === 'add' || this.$route.params.edit === 'edit') && !vm.isController;

                if (vm.info.User.MainRole !== 'administrators' && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksController) && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksEdit)) {
                    //if (!vm.isController && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksPage)) {
                    //    vm.back();
                    //    return new Promise(resolve => resolve());
                    //} else
                        if (vm.isController) {
                        vm.back();
                        return new Promise(resolve => resolve());
                    }
                }
                if (vm.isController) vm.titleName = 'Задание на проверке';
                else if (vm.answerId > 0 && vm.allowEdit) vm.titleName = 'Редактирование ответа';
                else if (vm.answerId > 0) vm.titleName = 'Просмотр ответа';
                else vm.titleName = 'Добавление ответа';

                return backendApi.tasksAnswerLoad(taskId, vm.answerId, tradePointId).then(function (response) {
                        //console.info('project.edit -> load, response:', response.data);
                    if (response.hasError) {
                        if (response.status === 401) {
                            UI.toastr.error('Нет доступа');
                            vm.back();
                        } else
                            UI.toastr.error('Ошибка при загрузке задания');
                    } else {
                        if (response.data == null) {
                            vm.$router.back();
                        }
                        if (vm.info.User.MainRole !== 'administrators' && response.data.task.DenyExecutionOnSite
                            && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.ttAccess)) {
                            UI.toastr.error('Нет доступа');
                            vm.$router.back();
                        }

                        vm.task = Object.assign(response.data.task);
                        vm.fieldTable.minItems = vm.task.FieldTableMinRows == null ? 0 : vm.task.FieldTableMinRows;
                        vm.fieldTable.maxItems = vm.task.FieldTableMaxRows == null ? 0 : vm.task.FieldTableMaxRows;
                        vm.fieldTable.ReportDate = { reportDate: vm.currentAnswer.FillingDate };

                        vm.taskId = vm.task.Id;
                        vm.task.TasksAttachments.forEach(x => {
                            x.Extension = x.FileName.split('.').pop();
                        });
                        vm.task.LastStatusSelectAnswer = JSON.parse(vm.task.LastStatusSelectAnswer);
                        vm.task.CaptionFormatted = vm.task.Caption ? vm.task.Caption.replace(/\n/g, '<br>') : null;
                        vm.currentAnswer = Object.assign(response.data.currentAnswer);
                        vm.currentAnswer.FillingDateFormatted = moment(vm.currentAnswer.FillingDate).format('DD.MM.YYYY');
                        vm.currentAnswer.FillingDateLong = moment(vm.currentAnswer.FillingDate).format('DD.MM.YYYY HH:mm');
                        if (vm.currentAnswer.DateOpen) {
                            vm.currentAnswer.DateOpenLong = moment(vm.currentAnswer.DateOpen).format('DD.MM.YYYY HH:mm');
                        }

                        vm.allowEdit = vm.allowEdit && vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend) && vm.currentAnswer.UserId === vm.info.User.Id &&
                            (vm.task.LastStatusSelectAnswer.Id === TaskAnswerStates.WaitingVerification ||
                            vm.task.LastStatusSelectAnswer.Id === TaskAnswerStates.Finalized ||
                            vm.task.LastStatusSelectAnswer.Id === TaskAnswerStates.OnEdition ||
                            vm.answerId === 0)
                            || vm.isController && (vm.task.LastStatusSelectAnswer.Id === TaskAnswerStates.WaitingVerification || vm.task.LastStatusSelectAnswer.Id === TaskAnswerStates.Finalized);
                        if(vm.allowEdit && vm.task.LastStatusSelectAnswer.Id !== TaskAnswerStates.OnEdition && vm.task.EndDate < vm.task.Now) {
                            vm.allowEdit = false;
                        }
                        vm.fieldTable.canBeEdited = vm.allowEdit;

                        if (vm.answerId === 0 && !vm.currentAnswer.TradePoint && vm.task.FixTT) {
                            vm.loadNextTradePoints();
                        } else if (vm.currentAnswer.TradePoint) {
                            vm.fieldTable.TradePoint = vm.currentAnswer.TradePoint;
                        }

                        //console.info('vm.fieldTable', vm.fieldTable, vm.fieldSettingsSku, vm.allowEdit);
                        switch (vm.task.ScoringAccrual){
                          case ScoringAccrualType.FACT:
                            vm.fieldTable.bonusSettings.bonusStrategy = {
                              type: 'fact',
                              data: {
                                value: vm.task.ScoringAccrualSum
                              }
                            }
                            break;
                          case ScoringAccrualType.PERCENT:
                            vm.fieldTable.bonusSettings.bonusStrategy = {
                              type: 'percent',
                              data: {
                                fieldId: vm.task.ScoringAccrualField,
                                value: vm.task.ScoringAccrualSum
                              }
                            }
                            break;
                          case ScoringAccrualType.PER_SKU:
                            vm.fieldTable.bonusSettings.bonusStrategy = {
                              type: 'perSku',
                              data: {
                                fieldId: vm.task.ScoringAccrualField,
                                value: vm.task.ScoringAccrualSum
                              }
                            }
                            vm.fieldTable.skuBonusList = vm.task.SkuBonusList
                            break;
                          default:
                            break;
                        }
                    }
                    })
            },

            saveAnswer(status, comment, saveOnly) {
                let vm = this;
                let taskId = parseInt(this.$route.params.taskId);

                Promise.all([vm.$refs.reportItems ? vm.$refs.reportItems.validate() : null, vm.$validator.validate()]).then(results => {
                    if (vm.$refs.reportItems && !results[0] || !results[1]) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {

                        vm.task.Id = taskId;
                        let saveObj = {TaskId: taskId, AnswerId: vm.answerId, Attachments: [], Status: status, Comment: comment};

                        for (let s of vm.FieldSettings) {
                            if (s.type === 'attach') {
                                if (s.Attachments.length === 0) {
                                    UI.toastr.error('Не добавлено вложение');
                                    return;
                                } else {
                                    saveObj.Attachments.push({ Id: s.id, Files: Object.assign(s.Attachments) });
                                }
                            }
                        }
                        if (vm.fieldTable.ReportItems.length > 0) {
                            saveObj.ReportItems = Object.assign(vm.fieldTable.ReportItems);
                        } else if (vm.task.FieldInputType === vm.FieldType.Table) {
                            UI.toastr.error('Проверьте введённые данные, необходимо добавить хотя бы одну строку!');
                            return;
                        }
                        if (vm.answerId === 0 && vm.currentAnswer.TradePoint) {
                            saveObj.TradePointId = vm.currentAnswer.TradePoint.Id;
                        }

                        UI.blockUI('.dataContent', 'Сохранение...');

                        saveObj.SaveOnly = saveOnly

                        backendApi.tasksAnswerSave(saveObj).then(function (response) {
                            if(response.hasError) {
                                switch(response.status) {
                                    case 721:
                                        UI.toastr.error('Время на выполнение задания истекло.');
                                        break;
                                    case 722:
                                        UI.toastr.error('Отправить на доработку можно только тот ответ, по которому бонусы не были истрачены.');
                                        break;
                                    case 723:
                                        UI.toastr.error('Отклонить можно только тот ответ, по которому бонусы не были истрачены.');
                                        break;
                                    case 724:
                                        UI.toastr.error('Удалить можно только тот ответ, по которому бонусы не были истрачены.');
                                        break;
                                    default:
                                        UI.toastr.error('Ошибка при сохранении задания');
                                        break;
                                }
                            } else {
                                UI.toastr.success('Успешно сохранено');
                                if(status > 0) {
                                    vm.$refs['ppComment'].close();
                                }
                                vm.back();
                                //vm.$router.push('/tasks/' + taskId);
                            }
                            UI.unblockUI('.dataContent');
                        });
                    }
                });
            },

            loadAnswersDetail() {
                let vm = this;
                vm.answerId = parseInt(this.$route.params.answerId);
                vm.taskId = parseInt(this.$route.params.taskId);
                UI.blockUI('.dataContent', 'Загрузка...');
                this.callApiWrapper(backendApi.tasksAnswersDetail(vm.taskId, vm.answerId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки ответов');
                        }
                        else {
                            if (resp.data.items && resp.data.items.length) {
                                vm.fieldTable.ReportItems.push(...resp.data.items);
                            } 

                            if (resp.data.fieldSettings) {
                                vm.FieldSettings = Object.assign(resp.data.fieldSettings);
                                let fields = [];
                                let totalSeconds = (new Date()).getTime();
                                for (let s of vm.fieldSettingsOrdered) {
                                    if (s.type === 'select') {
                                        s.optionsItems = JSON.parse(s.options).map(x => ({ Value: x, Name: x }))
                                    }
                                    else if (s.type === 'attach') {
                                        if (s.Attachments == null)
                                            s.Attachments = [];
                                        else {
                                            s.Attachments.forEach(x => {
                                                x.Extension = x.FileName.toLowerCase().split('.').pop();
                                                if(x.FilePath && x.FilePath.indexOf('?') === -1)
                                                    x.FilePath = x.FilePath + '?' + totalSeconds;
                                            });
                                        }
                                        vm.existsAttach = true;
                                        s.accept = "";
                                        if (s.options) {
                                            let options = JSON.parse(s.options);
                                            if (options.indexOf('photo') > -1) {
                                                s.attach_photo = true;
                                                s.accept = ".jpg,.jpeg,.png";
                                            }
                                            if (options.indexOf('doc') > -1) {
                                                s.attach_doc = true;
                                                s.accept = s.accept + ",.docx,.xlsx";
                                            }
                                        }
                                        continue;
                                    }
                                    vm.fieldTable.reportSettings.push(s);
                                    fields.push({ Name: s.name, Value: null, Title: null, Type: s.type});
                                }
                            }
                        }
                        UI.unblockUI('.dataContent');
                    })
            },

            onRemoveAttachment(settings,i) {
                if (confirm('Удалить файл?')) {
                    settings.Attachments.splice(i, 1);
                    //this.$refs.dropFiles2.value = '';
                }
            },

            btnAccept(status, comment) {
                let vm = this;
                //vm.answerId = parseInt(this.$route.params.id);
                let taskId = parseInt(this.$route.params.id);
                //console.info(taskId, vm.answerId, status);
                UI.blockUI('.dataContent', 'Сохранение...');
                backendApi.tasksAnswerAccept(taskId, vm.answerId, status, comment).then(function (response) {
                    if(response.hasError) {
                        switch(response.status) {
                            case 722:
                                UI.toastr.error('Отправить на доработку можно только тот ответ, по которому бонусы не были истрачены.');
                                break;
                            case 723:
                                UI.toastr.error('Отклонить можно только тот ответ, по которому бонусы не были истрачены.');
                                break;
                            case 724:
                                UI.toastr.error('Удалить можно только тот ответ, по которому бонусы не были истрачены.');
                                break;
                            default:
                                UI.toastr.error('Ошибка при сохранении');
                                break;
                        }
                    } else {
                        UI.toastr.success('Успешно сохранено');
                        vm.$refs['ppComment'].close();
                        vm.back();
                    }
                    UI.unblockUI('.dataContent');
                });
            },

            validatePopup() {
                let vm = this;
                this.$validator.validate().then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                        return;
                    } else {
                        if(vm.selectStatus === 4)
                            vm.saveAnswer(vm.selectStatus, vm.commentStatus);
                        else
                            vm.btnAccept(vm.selectStatus, vm.commentStatus);
                    }
                });
            },

            btnReject(state) {
                let vm = this;
                vm.selectStatus = state;
                vm.commentStatus = '';

                if (state === 4)
                    vm.popuptitle = 'Причина отправки на доработку';
                else
                    vm.popuptitle = 'Причина отклонения';
                vm.$refs['ppComment'].show();

                vm.$nextTick(() => {
                    vm.$refs.ppComment.show();
                });
            },

            closeModal(popupName) {
                this.$refs[popupName].close();
            },

            onInfoOpen() {
                this.$refs['ppInfo'].show();
            },

            onAttachFiles(obj) {
                let files = obj.files;
                let fieldId = obj.id;
                let accept = obj.accept;
                let filename = '';
                //console.info();
                let is_photo = accept.indexOf('jpg') > -1;
                let is_doc = accept.indexOf('docx') > -1;
                let vm = this;
                if (files && files.length) {
                    for (let file of files) {
                        filename = file.name.toLowerCase();
                        if (is_photo && (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png')) ||
                            is_doc && (filename.endsWith('.docx') || filename.endsWith('.xlsx'))) {
                            if (file.size > 50 * 1024 * 1024) {
                                UI.toastr.error('Превышен размер. Выберите другой файл');
                                $('[name="dropFiles"]').val('');
                            } else {
                                //console.info('file:', filename.indexOf('.doc'), filename);
                                let img = { FileName: file.name, FileData: null, Delete: false, FieldId: fieldId, Extension: '' };
                                if (filename.indexOf('.xls') > -1) img.Extension = 'xlsx';
                                else if (filename.indexOf('.doc') > -1) img.Extension = 'docx';
                                else img.isImage = true;

                                let reader = new FileReader();
                                reader.onload = function (e) {
                                    img.FileData = e.target.result;
                                    let field = vm.FieldSettings.find(x => x.id === fieldId);
                                    field.Attachments.push(img);
                                };
                                reader.readAsDataURL(file);
                            }
                        }
                        else {
                            if (is_photo && is_doc)
                                UI.toastr.error('Не верный формат файла ' + filename + ', разрешено: .jpg,.jpeg,.png,.docx,.xlsx');
                            else if (is_photo)
                                UI.toastr.error('Не верный формат файла ' + filename + ', разрешено: .jpg,.jpeg,.png');
                            else if (is_doc)
                                UI.toastr.error('Не верный формат файла ' + filename + ', разрешено: .docx,.xlsx');
                            else
                                UI.toastr.error('Не верный формат файла ' + filename + ', к сожалению, разрешенные форматы не указаны');
                        }
                    }
                }
            },

            searchSkuFunction(searchText, callback, extra, page, fieldName) {
                let vm = this;
                let colSetting = vm.fieldTable.reportSettings.find(x => { return x.name === fieldName });
                let tradePointId = 0;
                if (vm.currentAnswer.TradePoint)
                    tradePointId = vm.currentAnswer.TradePoint.Id;
                //if ((page - 1) === 0) callback(vm.sku);
                vm.callApiWrapper(backendApi.skuSearchForTable((page - 1) * 20, 20, tradePointId, searchText, fieldName, colSetting.id, vm.fieldTable.bonusSettings.skuView))
                    .then(function (resp) {
                        callback(resp.data);
                    });
            },

            getSkuSelectedItem(field) {
                //console.info('getSkuSelectedItem', field.ValueInt, field.Title);
                return {
                    Id: field.Value,
                    Name: field.Title
                }
            },

            onChangeSkuSearch(listItem, extra, fieldName) {
                let vm = this;
                // тип ввода: таблица
                if (vm.fieldTable.ReportItems.length > 0) {
                    let field = vm.fieldTable.ReportItems[extra].Fields.find(x => { return x.Type === 'sku' && x.Name === fieldName });
                    //field.Value = listItem ? listItem.Id : null;
                    if (listItem) {
                        field.Value = listItem.Id;
                        field.Title = listItem.Name;
                    } else {
                        field.Value = null;
                        field.Title = null;
                    }
                }
            },

            onSelectTradePoint(tt) {
                this.currentAnswer.TradePoint = tt;
                //this.loadAnswersDetail();
                this.fieldTable.TradePoint = this.currentAnswer.TradePoint;
            },

            onChangeTradeSearch: _.debounce(function () {
                this.ttPage = 1;
                this.ttData = [];
                this.loadNextTradePoints();
            }, 300),

            onReportItemsScroll(e) {
                let vm = this;
                if (vm.currentAnswer.TradePoint == null && !vm.ttIsLoading && vm.ttCanBeLoaded) {
                    let elem = $(e.target);
                    if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                        vm.ttPage++;
                        vm.loadNextTradePoints();
                    }
                }
            },

            loadNextTradePoints() {
                let vm = this;

                vm.ttSearched = true;

                let searchText = vm.ttSearch;
                vm.ttIsLoading = true;
                UI.blockUI('.dataContent', 'Загрузка...');
                vm.callApiWrapper(backendApi.tradePointListForReport((this.ttPage - 1) * 50, 50, vm.task.ProjectId, searchText, null))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки торговых точек');
                        }
                        else {
                            let filteredData = resp.data;

                            // Фильтрация списка точек
                            if (vm.task.MemberFilterVariant === MemberFilters.TradePoints) {
                                const filterField = vm.task.MemberFilterField;
                                const filterValue = JSON.parse(vm.task.MemberFilterValue).map(item => item.Name);

                                filteredData = filteredData.filter(point => filterValue.includes(point[filterField]));
                            }

                            // Добавление отфильтрованных данных в общий массив
                            if (filteredData.length) {
                                vm.ttData.push(...filteredData);
                                // Проверка на количество точек в массиве
                                if (vm.ttData.length === 1) {
                                  vm.currentAnswer.TradePoint = vm.ttData[0];
                                    vm.fieldTable.TradePoint = vm.currentAnswer.TradePoint;
                                }
                            } else {
                                vm.ttCanBeLoaded = false;
                            }
                        }

                        UI.unblockUI('.dataContent');
                        vm.ttIsLoading = false;
                    })

            },

            formatTradePointName(tradePoint) {
                let arr = [];
                if (tradePoint.Region) {
                    arr.push(tradePoint.Region)
                }
                if (tradePoint.City) {
                    arr.push(tradePoint.City)
                }
                if (tradePoint.Address) {
                    arr.push(tradePoint.Address)
                }
                return tradePoint.Name + (arr.length ? ' (' + arr.join(', ') + ')' : '');
            },

            skuSelectedItem() {
                let vm = this;
                if (vm.tradePointSelected && vm.task.FieldInputType === vm.FieldType.Single) {
                    let field = vm.FieldSettings.find(x => x.type === 'sku');
                    //console.info('sku_selectedItem', vm.$refs.searchfilter);
                    if (field)
                        vm.skuValueItem++;
                        //vm.searchfilter_selectedItem_Init();
                        //vm.$refs.searchfilter.searchfilter_selectedItem_Init();
                }
            },

            rotateImage(direction, item) {
                let vm = this;

                vm.callApiWrapper(backendApi.commonImageRotation(item.FilePath, direction))
                    .then(function (response) {
                        if(response.hasError) {
                            UI.toastr.error('Ошибка при изменении изображения');
                        } else {
                            item.FilePath = response.data;
                        }
                    });
            }
        },

        mounted() {
            let vm = this;
            vm.fieldTable = {
                bonusSettings: {
                    bonusStrategy: {
                        type: ''
                    },
                    skuView: 'tasks'
                },
                TradePoint: { Id: 0, SkuLink: '' },
                reportSettings: [],
                equipmentTypes: [{ Id: 0, Name: '' }],
                sku: [{ Id: -1, Name: '' }],
                ReportDate: { reportDate: null },
                canBeEdited: vm.allowEdit,
                minItems: 0,
                maxItems: 0,
                ReportItems: [],
                skuBonusList: []
            };

            UI.blockUI('.dataContent', 'Загрузка...');
            Promise.all([this.loadTask(), this.loadAnswersDetail()]).then(() => {
                
                UI.unblockUI('.dataContent');

                $(document).on('change', '[name="atDropFiles2"]', function () {
                    let fieldId = $(this).data('fieldid');
                    vm.onAttachFiles({ files: this.files, id: fieldId, accept: $(this)[0].accept });
                });

                vm.imgmixin_lightzoomInit();
                vm.CommonMixin_doubleRequestAnimationFrame(() => {
                    $('.lightzoom-type2').fancybox({
                        beforeShow: function () {
                            let downloadpath = $.fancybox.wrap.find('.fancybox-image').attr('src');
                            let $btn = $('<a href="' + downloadpath + '" class="btn" download>Скачать</a>');
                            let $div = $(`<div class="btns flex">
    <button type="button" class="btn btn-primary margin-top-15 zoom-plus btn-img"><img src="/Content/dist/icon-plus-2.png" alt=""></button>
    <button type="button" class="btn btn-primary margin-top-15 zoom-minus btn-img"><img src="/Content/dist/icon-minus-2.png" alt=""></button>
    </div>`);
                            $.fancybox.wrap.find('.fancybox-outer').after($btn);
                            $.fancybox.wrap.find('.fancybox-outer').before($div);
                            $.fancybox.wrap.find('img.fancybox-image').draggable();
                        },
                        afterClose: function () {
                            $('.lightzoom-type2').css({"display": "block"});
                        }
                    });
                });
            });
        },

        destroyed(){
            $(document).off('change', '[name="atDropFiles2"]');
            $(document).off('click', '.block-in-page-collapce');
        }
    }
</script>

<style scoped>
    button.img-download {left: 50%;position: relative;argin-left: -35px;}
    .fancybox-inner {overflow: hidden !important;}
    .fancybox-nav {width: 40px !important;}
    .thumbnail-img-file {width: auto;height: 50px;padding: 10px 25px 10px 10px;}
    .thumbnail-img-file .thumbnail-img-delete {right: 0px;bottom: 16px;}
    .panel-block-large.panel-block {overflow: visible;z-index: auto;}
    .panel-block-large .panel-block-info {z-index: auto;}
    .panel-block-field{width:100%}
    .thumbnail-img-rotateleft{right:55px;}
    .thumbnail-img-rotateright{right:35px;}
</style>


// WEBPACK FOOTER //
// Content/src/views/edit/TasksAnswerEdit.vue